// ============================================
// VARIANT COLOR SWATCHER
// Works on both desktop and mobile
// ============================================
document.addEventListener('DOMContentLoaded', function() {
  
  // Initialize variant swatchers for all products
  document.addEventListener("click", function(e) {
    let btn = e.target.closest(".product-item__color-variant");
    let arrow = e.target.closest(".product-items-arrow-wrapper");

    if (btn) {
      e.preventDefault();

      const productItem = btn.closest(".product-item");
      if (!productItem) return;

      const variantButtons = productItem.querySelectorAll(".product-item__color-variant");
      const mainProductImage = productItem.querySelector('.product-item__image-wrapper img');

      const index = [...variantButtons].indexOf(btn);


      variantButtons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      const image = btn.getAttribute("data-variant-image");
      if (image && mainProductImage) {
        mainProductImage.src = image;
        mainProductImage.srcset = image;
      }

      const id = btn.getAttribute("data-variant-id");
      const inner = btn.closest('.product-item__inner');
      if (!inner) return;

      const swiperEl = inner.querySelector('.product_item_image.swiper');
      if (!swiperEl || !swiperEl.swiper) return;

      const swiper = swiperEl.swiper;
      const slides = swiperEl.querySelectorAll('.swiper-slide');

      let targetIndex = -1;
      slides.forEach((slide, i) => {
        var variantMedia = slide.getAttribute("data-variants_media");
        if (variantMedia && variantMedia.split(",").includes(id)) {
          targetIndex = i;
        }
      });

      if (targetIndex >= 0) {
        swiper.slideToLoop(targetIndex);
      }
    }

    if (arrow) {
      e.preventDefault();

      const productItem = arrow.closest(".product-item");
      if (!productItem) return;

      const variantButtons = productItem.querySelectorAll(".product-item__color-variant");
      if (!variantButtons.length) return;

      let current;
      variantButtons.forEach((variantButton, index) => {
        if (variantButton.classList.contains('active')) {
          current = index;
        }
      });
      let next = (current + 1) % variantButtons.length;
      let nextBtn = variantButtons[next];

      // nextBtn.click(); 
    }
  });




  // // ============================================
  // // GRID LAYOUT SWITCHER (Mobile Only)
  // // ============================================
  // const layoutSwitcherButtons = document.querySelectorAll('.collection-product-grid-icon .grid-icon');
  // const productGrid = document.querySelector('.bd-main-collection-product-grid .collection__products');

    
  // if (layoutSwitcherButtons.length > 0 && productGrid) {
      
  //   // Load saved layout on page load
  //   const savedLayout = localStorage.getItem('gridLayout') || 'mixed';
  //   productGrid.classList.add('grid-layout-' + savedLayout);

  //   // Set active icon based on saved layout
  //   const savedIcon = document.querySelector('.grid-icon[data-layout-type="' + savedLayout + '"]');
  //   if (savedIcon) {
  //     savedIcon.classList.add('active');
  //   }

  //   console.log('productGrid :' + productGrid );
  //   // Add click handler to each layout icon
  //   layoutSwitcherButtons.forEach(function(icon) {
  //     icon.addEventListener('click', function() {
  //       const layoutType = this.getAttribute('data-layout-type');
        
  //       // Remove all layout classes
  //       productGrid.classList.remove('grid-layout-mixed', 'grid-layout-two-col', 'grid-layout-one-col');
        
  //       // Add selected layout class
  //       if (layoutType) {
  //         productGrid.classList.add('grid-layout-' + layoutType);
  //         localStorage.setItem('gridLayout', layoutType); // Save to localStorage
  //       }
        
  //       // Update active state on icons
  //       layoutSwitcherButtons.forEach(btn => btn.classList.remove('active'));
  //       this.classList.add('active');
  //     });
  //   });

  // }
  // // Sync grid icons on click & load
  // document.addEventListener('click', function(e) {
  //   const icon = e.target.closest('.grid-icon');
  //   if (icon) {
  //     const type = icon.getAttribute('data-layout-type');
  //     document.querySelectorAll('.grid-icon').forEach(i => i.classList.remove('active'));
  //     document.querySelectorAll('.grid-icon[data-layout-type="' + type + '"]').forEach(i => i.classList.add('active'));
  //   }
  // });
  
  // // Load saved state
  // const saved = localStorage.getItem('gridLayout') || 'mixed';
  // document.querySelectorAll('.grid-icon[data-layout-type="' + saved + '"]').forEach(i => i.classList.add('active'));

  // ============================================
  // GRID LAYOUT SWITCHER (Mobile Only) - MutationObserver + Delegation
  // ============================================

  // Helper: get current product grid (may return null)
  const getProductGrid = () =>
    document.querySelector('.bd-main-collection-product-grid .collection__products:not(.lf-product-grid)');

  // Apply layout class to a grid element
  const applyLayoutToGrid = (gridEl, layoutType) => {
    if (!gridEl) return;
    gridEl.classList.remove('grid-layout-mixed', 'grid-layout-two-col', 'grid-layout-one-col');
    gridEl.classList.add('grid-layout-' + layoutType);
  };

  // Read saved layout
  const savedLayout = localStorage.getItem('gridLayout') || 'mixed';

  // Initial apply if grid exists now
  const initialGrid = getProductGrid();
  if (initialGrid) {
    applyLayoutToGrid(initialGrid, savedLayout);
  }

  // Make icons reflect saved state (safe even if icons appear later)
  const setActiveIconByType = (type) => {
    document.querySelectorAll('.grid-icon').forEach(i => i.classList.remove('active'));
    document.querySelectorAll('.grid-icon[data-layout-type="' + type + '"]').forEach(i => i.classList.add('active'));
  };
  setActiveIconByType(savedLayout);

  // Use event delegation for clicks on layout icons ΓÇö always queries the current grid
  document.addEventListener('click', function (e) {
    const icon = e.target.closest('.grid-icon');
    if (!icon) return;

    const layoutType = icon.getAttribute('data-layout-type');
    if (!layoutType) return;

    // Always fetch fresh grid (it might have been replaced)
    const productGrid = getProductGrid();
    applyLayoutToGrid(productGrid, layoutType);

    // Persist and sync icons
    localStorage.setItem('gridLayout', layoutType);
    setActiveIconByType(layoutType);
  });

  // Keep icons in sync if some other code toggles one of them programmatically
  document.addEventListener('click', function (e) {
    const icon = e.target.closest('.grid-icon');
    if (!icon) return;
    const type = icon.getAttribute('data-layout-type');
    document.querySelectorAll('.grid-icon').forEach(i => i.classList.remove('active'));
    document.querySelectorAll('.grid-icon[data-layout-type="' + type + '"]').forEach(i => i.classList.add('active'));
  });

  // ------- MutationObserver: watch for replacement/insertion of product grid -------
  // Choose a stable parent to observe. Prefer the wrapper; fallback to body.
  const wrapper = document.querySelector('.bd-main-collection-product-grid') || document.body;

  let lastSeenGrid = initialGrid;

  // Function to run when grid appears/changes
  const handleGridChange = (gridEl) => {
    if (!gridEl) return;
    // if it's the same element reference, nothing to do
    if (gridEl === lastSeenGrid) return;
    lastSeenGrid = gridEl;

    // Apply saved layout (so newly injected grid respects user's choice)
    const layoutToApply = localStorage.getItem('gridLayout') || 'mixed';
    applyLayoutToGrid(gridEl, layoutToApply);

    // Optionally, run any initialization logic you need for the grid here
    // console.log('Grid replaced/inserted ΓÇö applied layout:', layoutToApply);
  };

  // Observe child additions/removals anywhere inside wrapper
  const observer = new MutationObserver((mutations) => {
    // On any mutation, try to find the product grid and handle it
    // Minimal work per mutation to avoid heavy loops
    const grid = getProductGrid();
    if (grid) handleGridChange(grid);
  });

  // Observe childList & subtree changes so we catch replacements and inner HTML swaps
  observer.observe(wrapper, { childList: true, subtree: true });

  // Also protect against the edge-case where wrapper itself is replaced:
  // observe document.body for the wrapper being re-inserted (cheap check, low frequency)
  if (wrapper !== document.body) {
    const bodyObserver = new MutationObserver(() => {
      const newWrapper = document.querySelector('.bd-main-collection-product-grid') || null;
      if (newWrapper && newWrapper !== wrapper) {
        // Re-run a grid detection ΓÇö handleGridChange will be called by the other observer when needed
        const grid = getProductGrid();
        if (grid) handleGridChange(grid);
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  
  // Smooth filter toggle
  const bottomFilter = document.querySelector('.bd-main-collection-product-grid .collection__filters');
  const topFilter = document.querySelector('.mobile-filters.mobile-filter-stick-top');
  
  if (bottomFilter && topFilter) {
    // Hide on load
    bottomFilter.classList.add('hide-filter');

    // Run scroll listener
    window.addEventListener('scroll', toggleFilter, { passive: true });
  }

  function toggleFilter() {
    const rect = topFilter.getBoundingClientRect();
    const visible = rect.top < window.innerHeight && rect.bottom > 0;

    // If top filter is visible ΓåÆ hide bottom
    bottomFilter.classList.toggle('hide-filter', visible);

    // If top filter is NOT visible ΓåÆ show bottom
    bottomFilter.classList.toggle('show-filter', !visible);
  }

  let productCard = document.querySelectorAll('.collection-product-card');

  if (productCard.length > 0) {
    console.log("Here is the collection wrapper image section-----------1");
    productCard.forEach((card) => {
      card.addEventListener('click', () => {
        card.classList.toggle('expanded');
        card.classList.toggle('collapsed');
      });
    });
  }
});


// ============================================
// KACHEL-PREIS PRO VARIANTE
// Der Farbkreis-Klick (und das Wischen im Bild-Swiper) setzt nur die Klasse
// "active" am Farbkreis. Hier ziehen wir den Preis und den Rabatt-Aufkleber der
// Kachel nach. Die Werte stehen als data-variant-* am Farbkreis (product-item.liquid).
// Ein MutationObserver faengt jeden Weg ab, der "active" verschiebt.
// ============================================
(function () {
  function nnBuildPrice(main, saleLabel, price, compare) {
    var doc = main.ownerDocument;
    main.textContent = '';
    if (compare) {
      var wrap = doc.createElement('div');
      wrap.className = 'product-item__price-sale';
      var label = doc.createElement('span');
      label.className = 'product-item__sale-label paragraph-small';
      label.textContent = saleLabel;
      var old = doc.createElement('s');
      old.className = 'product-item__compare-price paragraph-small bfcm-3-ab-test-a';
      old.textContent = compare;
      var now = doc.createElement('span');
      now.className = 'product-item__sale-price paragraph-small';
      now.textContent = price;
      // Leerzeichen zwischen den Spans wie im Server-HTML (Abstand sieht sonst anders aus)
      wrap.appendChild(label);
      wrap.appendChild(doc.createTextNode(' '));
      wrap.appendChild(old);
      wrap.appendChild(doc.createTextNode(' '));
      wrap.appendChild(now);
      main.appendChild(wrap);
    } else {
      var plain = doc.createElement('span');
      plain.className = 'product-item__price';
      plain.textContent = price;
      main.appendChild(plain);
    }
  }

  function nnApplyVariantPrice(item) {
    try {
      var btn = item.querySelector('.product-item__color-variant.active');
      if (!btn) return;
      var price = btn.getAttribute('data-variant-price');
      var main = item.querySelector('.product-item__price-main');
      if (!price || !main) return;

      var id = btn.getAttribute('data-variant-id');
      if (main.getAttribute('data-nn-variant') === id) return;
      main.setAttribute('data-nn-variant', id);

      var compare = btn.getAttribute('data-variant-compare');
      var percent = btn.getAttribute('data-variant-percent');
      var wrapper = main.closest('.product-item__price-wrapper');
      var saleLabel = (wrapper && wrapper.getAttribute('data-nn-sale-label')) || 'Sale';
      nnBuildPrice(main, saleLabel, price, compare);

      // Prozent-Aufkleber nur anfassen, wenn er schon da ist und eine Prozentzahl zeigt
      // (der Text-Modus "Eigener Text" bleibt unberuehrt).
      var badge = item.querySelector('.product-item-discount');
      if (badge) {
        if (!badge.hasAttribute('data-nn-badge-prozent')) {
          badge.setAttribute('data-nn-badge-prozent', /^\s*-\d+\s*%\s*$/.test(badge.textContent) ? '1' : '0');
        }
        if (badge.getAttribute('data-nn-badge-prozent') === '1') {
          if (compare && percent) {
            badge.textContent = '-' + percent + '%';
            badge.style.display = '';
          } else {
            badge.style.display = 'none';
          }
        }
      }
    } catch (err) {
      /* Preis bleibt dann einfach stehen wie bisher */
    }
  }

  function nnStartPriceObserver() {
    if (typeof MutationObserver === 'undefined' || !document.body) return;
    new MutationObserver(function (mutations) {
      var items = [];
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (!t.classList || !t.classList.contains('product-item__color-variant')) continue;
        var item = t.closest('.product-item');
        if (item && items.indexOf(item) === -1) items.push(item);
      }
      items.forEach(nnApplyVariantPrice);
    }).observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', nnStartPriceObserver);
  } else {
    nnStartPriceObserver();
  }
})();
